import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import Select from 'react-select';
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import styles from './styles.scss'
import Dialog from 'react-toolbox/lib/dialog'
import ProductFamilySagas from './sagas'
import InputWrapper from 'components/custom/InputWrapper'
import {
    activeAddProductFamilyDialogSelector,
    partnerSiteListSelector,
    formattedPartnerSiteListSelector,
    selectedPartnerSite,
    formattedProductFamilyListSelector,
    selectedProductFamily
} from './selectors'
import { 
    setInactiveProductFamilyDialog,
    setPartnerSiteChangeQuery,
    updateSelectedPartnerSite,
    updateSelectedProductFamily,
    saveSupportTeam
 } from './actions'
import PartnerSiteTeam from '../PartnerSiteRole/PartnerSiteTeam'

const mapStateToProps = (state) => {
    return {
        active: activeAddProductFamilyDialogSelector(state),
        partnerSiteList: formattedPartnerSiteListSelector(state),
        selectedPartnerSite: selectedPartnerSite(state),
        productFamilyList: formattedProductFamilyListSelector(state),
        selectedProductFamily: selectedProductFamily(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setInactiveAddDialog: () => dispatch(setInactiveProductFamilyDialog()),
        changePartnerSiteQuery: (query) => dispatch(setPartnerSiteChangeQuery(query)),
        updateSelectedPartnerSite: (value) => dispatch(updateSelectedPartnerSite(value)),
        updateSelectedProductFamily: (value) => dispatch(updateSelectedProductFamily(value)),
        saveSupportTeam: () => dispatch(saveSupportTeam())
    }
}


class ProductFamilyAddDialog extends Component {

    renderProductFamily = (props) => {
        if (props.selectedPartnerSite) {
            return (
                props.selectedPartnerSite.value ? (
                    <InputWrapper label="Product Family">
                        <Select
                            value={props.selectedProductFamily}
                            options={props.productFamilyList}
                            onChange={props.updateSelectedProductFamily}
                            placeholder={'Product Families in `Partner Site`'}
                            labelKey='label'
                            valueKey='value'
                        />
                    </InputWrapper>
                ) : ''
            )
        }
    }

    renderSupportTeam = (props) => {
        if (props.selectedProductFamily) {
            return (
                props.selectedProductFamily.value ? (
                    <PartnerSiteTeam />
                ) : ''
            )
        }
    }
    render() {
        const {
            active,
            setInactiveAddDialog,
            changePartnerSiteQuery,
            partnerSiteList,
            updateSelectedPartnerSite,
            selectedPartnerSite,
            saveSupportTeam
        } = this.props
        const actions = [
            { label: 'Save', onClick: saveSupportTeam},
            { label: 'Cancel', onClick: setInactiveAddDialog}
        ]
        return (
            <div>
                <Dialog
                    className={styles.dialog}
                    actions={actions}
                    active={active}
                    title='Add Product Family Support Team'
                    onOverlayClick={setInactiveAddDialog}
                    onEscKeyDown={setInactiveAddDialog}
                >
                    <React.Fragment>
                        <InputWrapper label="Partner Site">
                            <Select
                                value={selectedPartnerSite}
                                options={partnerSiteList}
                                onChange={updateSelectedPartnerSite}
                                onInputChange={changePartnerSiteQuery}
                                placeholder={'Choose Existing Partner Site'}
                                labelKey='label'
                                valueKey='value'
                            />
                        </InputWrapper>
                        {this.renderProductFamily(this.props)}
                    </React.Fragment>
                    {this.renderSupportTeam(this.props)}
                </Dialog>

            </div>
        )
    }
}


const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)
const withSagas = injectSagas({ ProductFamilySagas })

export default compose(
    withConnect,
    withStyle,
    withSagas
)(ProductFamilyAddDialog)

